import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-navy relative overflow-hidden" data-id="element-97">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-light/20 via-navy to-navy pointer-events-none" data-id="element-98"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-101">
            Next Monday you can keep improvising...
            <br data-id="element-102" />
            <span className="text-turquoise-gradient" data-id="element-103">
              Or you can walk into your classroom with everything ready starting
              today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-navy-dark p-8 rounded-2xl border border-navy-light" data-id="element-104">
            {['No more Sunday nights searching for ways to make Spanish grammar interesting', 'No more lessons thrown together at the last minute with material that does not work', 'No more disengaged students who think Spanish has nothing to do with their lives', 'No more weekends lost building lesson plans and assessments from scratch', 'No more uncomfortable silences when a student asks a question you are not ready for', 'No more emergency sub days that become classroom chaos', 'No more heritage speakers who feel invisible in your classroom'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-105">
                <span className="text-turquoise mt-1" data-id="element-106">▸</span>
                <span className="text-white/80" data-id="element-107">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-108">
            Spanish Ready™ does not make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-turquoise mb-6" data-id="element-109">
            You are already a great teacher.
          </p>
          <p className="text-xl text-white/80 mb-16" data-id="element-110">
            What Spanish Ready™ does is give you the time and the tools to let
            that show in every single class.
          </p>
        </div>

        <div className="bg-navy-dark border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-111">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-navy-light pb-6" data-id="element-112">
            Everything that is included:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-113">
            {['Module 1 — Speaking & Conversation', 'Module 2 — Reading & Writing', 'Module 3 — Listening & Vocabulary', 'Module 4 — Grammar In Context', 'Module 5 — Cultural Immersion & Projects', 'Module 6 — Assessments & Emergency Lessons', 'BONUS 1 — Spanish Conversation Cards Pack', 'BONUS 2 — No-Prep Spanish Activities Pack', "BONUS 3 — Spanish Teacher's Emergency Vault", 'BONUS 4 — Hispanic Culture Classroom Pack', 'BONUS 5 — Spanish Assessments and Rubrics Pack', '7-day money-back guarantee — no questions asked', 'Immediate access after purchase', 'PDF format — print-ready and professionally formatted', 'Works for in-person and online teaching', 'You pay in your local currency'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-114">
                <Check size={18} className="text-turquoise shrink-0" data-id="element-115" />
                <span className="text-sm text-white/90" data-id="element-116">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-117">
            <div className="mb-8 p-6 bg-turquoise/5 rounded-xl border border-turquoise/20 italic text-white/80 text-lg" data-id="element-118">
              "The best time to have this system was at the beginning of the
              school year.
              <br data-id="element-119" />
              <span className="text-turquoise font-bold not-italic" data-id="element-120">
                The second best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-121">
              📚 Spanish Ready™ Mega Pack
            </p>
            <p className="text-sm text-white/60 mb-8" data-id="element-122">
              Built by language education specialists, for Spanish teachers in
              every English-speaking classroom in the world.
            </p>

            <Button href="https://spanish-ready.impultienda.ar/checkout" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-123">
              🟡 I WANT MY MEGA PACK NOW — $19.90
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-white/50" data-id="element-124">
              <span data-id="element-125">✅ 7-day money-back guarantee</span>
              <span data-id="element-126">✅ Secure payment</span>
              <span data-id="element-127">✅ Immediate access</span>
              <span data-id="element-128">✅ You pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}